import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { ISalesOffice } from '../../shared/models/core/sales-office';

export const salesOfficeApi = createApi({
  reducerPath: 'salesOfficeApi',
  baseQuery,
  endpoints: (builder) => ({
    currentSalesOffices: builder.query<ISalesOffice[], void>({
      query: () => ({
        url: '/api/salesoffices',
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyCurrentSalesOfficesQuery } = salesOfficeApi;
